/**
 * Come l'operatore edita un'etichetta preimballata (spec
 * 2026-09-06-label-free-mode-editor §4.1): `GUIDED` è la modalità storica in
 * cui il motore di regole impone i blocchi obbligatori; `FREE` rilassa quei
 * blocchi dietro attestazione firmata dell'operatore (Task 15). Un solo
 * elenco condiviso: backend (enum Prisma, DTO `@IsIn`) e frontend (parser
 * della project response) devono leggere le modalità dalla stessa costante.
 */
export const PREPACKAGED_LABEL_EDITOR_MODES = ['GUIDED', 'FREE'] as const;

export type PrepackagedLabelEditorMode = (typeof PREPACKAGED_LABEL_EDITOR_MODES)[number];

/** `unknown` on purpose: the value can arrive from a JSON column, a DTO or a
 *  draft the client still holds. Anything that is not exactly `'FREE'` edits
 *  in GUIDED — the default must fail closed. */
export function isFreeEditorMode(mode: unknown): boolean {
  return mode === 'FREE';
}
